import { SWRConfiguration, SWRResponse } from 'swr';
import { GetConsentEventDataResponse, GetConsentEventData } from '../../api/dtos';
import { useMemo } from 'react';
import { useGet } from '@ngt/opms';

export const PICF_VERSION_OTHER_ID = 0;

const getData = (response?: SWRResponse<GetConsentEventDataResponse, GetConsentEventDataResponse>) => {
    if (!response?.data) {
        return undefined;
    }

    const  { responseStatus: _responseStatus,  ...data} = response.data;
    
    return data;
};

const getError = (response?: SWRResponse<GetConsentEventDataResponse, GetConsentEventDataResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useConsentEventData = (guid?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return guid ?
            () => {
                return new GetConsentEventData({ guid });
            } :
            undefined;
    }, [guid])

    return useGet(request, { getData, getError }, configuration);
};

export default useConsentEventData;